import { render, staticRenderFns } from "./CardHolerite.vue?vue&type=template&id=2c045f02&scoped=true&"
import script from "./CardHolerite.vue?vue&type=script&lang=js&"
export * from "./CardHolerite.vue?vue&type=script&lang=js&"
import style0 from "./CardHolerite.vue?vue&type=style&index=0&id=2c045f02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c045f02",
  null
  
)

export default component.exports